<template>
  <v-list v-if="inscricao.arquivos?.length" dense elevation="2">
    <v-list-item v-for="documento in inscricao.arquivos" :key="documento.id">
      <v-list-item-title>{{ getNomeDocumento(documento) }}</v-list-item-title>
      <v-list-item-subtitle>{{
        format(parseISO(documento.data_cadastro), "dd/MM/yyyy HH:mm")
      }}</v-list-item-subtitle>
      <v-list-item-action>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon @click="onClickDocumento(documento)">
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>
          <span>Download</span>
        </v-tooltip>
      </v-list-item-action>
    </v-list-item>
  </v-list>

  <span v-else>Nenhum documento encontrado</span>
</template>

<script>
import { format, parseISO } from "date-fns";

const NOME_DOCUMENTO = [
  {
    title: "Criança em Vulnerabilidade Social (CRAS)",
    label: "declaracao_vulnerabilidade_social",
  },
  {
    title: "Anexo de Transferência",
    label: "anexo_transferencia",
  },
  {
    title: "Acolhimento Institucional (Documento comprobatório)",
    label: "declaracao_acolhimento_institucional",
  },
];

export default {
  name: "secao-07-documentos",

  props: {
    inscricao: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      NOME_DOCUMENTO,
    };
  },

  methods: {
    format,
    parseISO,

    onClickDocumento(documento) {
      this.$http
        .get(`/arquivos/inscricao/${documento.caminho}`, {
          responseType: "blob",
        })
        .then((blob) => {
          const url = URL.createObjectURL(blob);
          const contentType = blob.type || "application/octet-stream";
          const nomeArquivo = documento.caminho || "arquivo";

          // Se for PDF ou imagem, abre direto na aba
          if (contentType.includes("pdf") || contentType.includes("image")) {
            window.open(url, "_blank");
          } else {
            // Caso contrário, força o download
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", nomeArquivo);
            document.body.appendChild(link);
            link.click();
            link.remove();
          }

          // Libera a URL da memória após 10 segundos
          setTimeout(() => URL.revokeObjectURL(url), 10000);
        })
        .catch((error) => {
          this.showMessage(error, "error");
        });
    },

    getNomeDocumento(documento) {
      return (
        this.NOME_DOCUMENTO.find(
          (item) => item.label === documento.nome_arquivo,
        )?.title || documento.nome_arquivo
      );
    },
  },
};
</script>
